import { enUSMessages } from "./en-US"

type MessageId = keyof typeof enUSMessages

export const zhHansMessages: Record<MessageId, string> = {
  ...enUSMessages,
  "settings.language.option.zh-Hans": "简体中文",
}
